import { getSectionsDictionary } from '~/src/repositories/cms/shared/cms.base.repository';
import { CmsCategoryCodeEnum } from '~/src/models/enums/cms.enum';
import { getMappedInfoBannersData } from '~/src/repositories/cms/entities/leads/utils/cms.leads.utils';
import type { CmsInfoBannersArticleAttributeInterface } from '~/src/repositories/cms/entities/leads/types/cms.leads.types';

export const getInfoBannerData = async (isSSR?: boolean) => {
    const data = await getSectionsDictionary<CmsInfoBannersArticleAttributeInterface>({
        isSSR,
        categoryCode: CmsCategoryCodeEnum.INFO_BANNERS,
    });

    return getMappedInfoBannersData(data);
};
